export function CurrentTime (enableTime = true, enableDate = true) {
    const now = new Date();
    let today = '';
    let time = '';
    let once = '';
    if(enableTime) {
        time = `${now.getHours()}:${now.getMinutes().toString().padStart(2, "0")}`;
        once = time;
    }
    if(enableDate) {
        today = `${now.getMonth() + 1}-${now.getDate()}-${now.getFullYear()}`;
        once = today;
    }

    if(today && time) {
        return `${today} ${time}`;
    }
    else {
        return once;
    }
}